export default __webpack_public_path__ + "static/media/dixieKlein.0e0c1df1.jpg";